__turbopack_context__.v({
  "backdrop": "global-search-module__i_ZC0q__backdrop",
  "closeBtn": "global-search-module__i_ZC0q__closeBtn",
  "dialog": "global-search-module__i_ZC0q__dialog",
  "empty": "global-search-module__i_ZC0q__empty",
  "fadeIn": "global-search-module__i_ZC0q__fadeIn",
  "groupLabel": "global-search-module__i_ZC0q__groupLabel",
  "inputRow": "global-search-module__i_ZC0q__inputRow",
  "result": "global-search-module__i_ZC0q__result",
  "resultBody": "global-search-module__i_ZC0q__resultBody",
  "resultCookbookIcon": "global-search-module__i_ZC0q__resultCookbookIcon",
  "resultFocused": "global-search-module__i_ZC0q__resultFocused",
  "resultImg": "global-search-module__i_ZC0q__resultImg",
  "resultMeta": "global-search-module__i_ZC0q__resultMeta",
  "resultPlaceholder": "global-search-module__i_ZC0q__resultPlaceholder",
  "resultThumb": "global-search-module__i_ZC0q__resultThumb",
  "resultTitle": "global-search-module__i_ZC0q__resultTitle",
  "results": "global-search-module__i_ZC0q__results",
  "seeAll": "global-search-module__i_ZC0q__seeAll",
  "slideDown": "global-search-module__i_ZC0q__slideDown",
  "spin": "global-search-module__i_ZC0q__spin",
  "spinner": "global-search-module__i_ZC0q__spinner",
  "trigger": "global-search-module__i_ZC0q__trigger",
  "triggerText": "global-search-module__i_ZC0q__triggerText",
});
